<template>
  <div>
    <v-card :loading="downloading" :class="showResumeRequired ? 'error-border' : ''">
      <v-card-title> Upload Your Resume <small class="ml-2 error--text">*</small></v-card-title>
      <v-card-text>
        <v-col class="pt-0 pb-0">
          <p class="mb-0">PDF file</p>
          <p class="mb-0">Maximum file size: 5 MB</p>
        </v-col>

        <v-col md="12" sm="12" cols="12" class="pt-0 pb-0">
          <FileUploadField
            :readonly="isHiringmanager"
            v-model="currentFile"
            @change="fileChanged"
            class="mr-3"
            accept=".pdf"
            dense
            small-chips
            :show-size="showSize"
            outlined
            label="Please upload your resume"
          />
        </v-col>
        <v-col class="mt-0 pt-0" v-if="resumeMessage && resumeMessage.length > 0">
          <p v-for="message in resumeMessage" :key="message" class="mb-0 error--text">
            {{ message }}
          </p>
        </v-col>
        <v-col class="pt-0" v-if="personalDetailModel.CV">
          <p class="success-text">You already have uploaded a resume. you can download it or you can upload a new one</p>
          <v-col class="pt-0 text-center">
            <v-btn v-if="!isHiringmanager" class="secondary pt-0" fab title="Download" :loading="downloading" @click="downloadCV"
              ><v-icon>mdi-download</v-icon></v-btn
            >
            <v-btn v-if="!isHiringmanager" fab class="error ml-5" title="Delete" :loading="downloading" @click="removeCV">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-col>
      </v-card-text>
    </v-card>
  </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import TeamMemberService from "../../services/TeamMemberService";
import UploadProfilePhoto from "./UploadProfilePhoto.vue";
import FileUploadField from "../Fields/FileUploadField.vue";
import { PersonalDetailModel } from "../../models/PersonalDetailModel";

export default defineComponent({
  props: ["personalDetail", "isFileValid", "selectedTeammemberModel", "isHiringmanager"],
  components: {
    UploadProfilePhoto,
    FileUploadField,
  },
  data() {
    return {
      downloading: false,
      validResume: false,
      showSize: true,
      maxResumeFileSize: 5000000,
      resumeMessage: [] as string[] | null,
      showResumeRequired: false,
      resumeFileType: ["application/pdf"],
      personalDetailModel: {} as PersonalDetailModel,
      resumeFile: null as File | null,
      uploadImage: false,
      currentFile: null as File | null,
    };
  },
  mounted() {
    this.personalDetailModel = { ...this.personalDetail };
    if (this.personalDetailModel.CV) {
      this.validResume = true;
    }
  },
  watch: {
    isFileValid(newVal) {
      this.showResumeRequired = !newVal;
    },
    personalDetail(newVal) {
      this.personalDetailModel = { ...newVal };

      if (this.personalDetailModel.CV) {
        var filename = this.personalDetailModel.CV.substring(this.personalDetailModel.CV.lastIndexOf("/") + 1);
        if (filename != `${this.personalDetailModel.Id}.pdf`) {
          filename = filename.replace(this.personalDetailModel.Id, "");
        }
        this.currentFile = new File([], filename);
        this.showSize = false;
        this.validResume = true;
      }
    },
  },
  methods: {
    async removeCV() {
      this.personalDetailModel.CV = null;
      this.currentFile = null;
      this.resumeFile = null;
      this.validResume = false;
      this.fileChanged();
      this.downloading = true;
      var removeResult = await TeamMemberService.removeResume(this.selectedTeammemberModel ? this.selectedTeammemberModel.id : "");
      if (removeResult) {
        this.$emit("snackbarMessage", { message: "Your resume has been deleted successfully", type: "success" });
      } else {
        this.$emit("snackbarMessage", { message: "Couldn't delete resume file!", type: "error" });
      }
      this.downloading = false;
    },
    async fileChanged() {
      var file = this.currentFile;
      this.showSize = true;
      this.validResume = true;
      this.resumeMessage = [];
      if (!file && !this.personalDetailModel.CV) {
        this.resumeFile = file;
        this.validResume = false;
        this.resumeMessage?.push("Uploading resume is required!");
      } else if (file && file.size > this.maxResumeFileSize) {
        this.validResume = false;
        this.resumeMessage?.push("Large file! you can't upload a file that is more than 5 MB");
      } else if (file && !this.resumeFileType.includes(file.type)) {
        this.validResume = false;
        this.resumeMessage?.push("Wrong file type! you should only upload a PDF file");
      } else {
        this.resumeFile = file;
      }
      this.$emit("setResume", this.resumeFile);
      this.showResumeRequired = !this.validResume;
    },
    async downloadCV() {
      this.downloading = true;
      var downloadLink = await TeamMemberService.getResumeDownloadLink();
      if (downloadLink) {
        window.open(downloadLink, "_blank");
      } else {
        this.$emit("snackbarMessage", { message: "Your resume has been deleted from the server. please upload another file!", type: "error" });
        this.personalDetailModel.CV = null;
        this.resumeFile = null;
        this.currentFile = null;
        this.fileChanged();
      }
      this.downloading = false;
    },
  },
});
</script>
